import React from "react";
import {
  convertThenFormat,
  formatDateTimezon,
} from "../../common-data/Converts";
import { BodyBuilder } from "../../../exports/Images";
import PaginationModified from "../../../data/PaginationModified";

const ImportMemberMobile = ({
  tableData,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  tablePagination,
  setModValues,
  isAdmin,
}) => {
  function getPagination() {
    try {
      const pagination = tablePagination ? tablePagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="all-leads-log mt30">
      {tableData?.length > 0 &&
        tableData.map((row, index) => {
          const isEditable = row?.subscription_status === "active";

          return (
            <div className="log-card" key={index}>
              <div className="all-info-agent">
                <div className="tb-img lightBorderRadiusImg label-value-agent">
                  <span className="label">Profile</span>
                  <img
                    src={row?.profile || BodyBuilder}
                    alt={row?.user_name || "NA"}
                    className="image"
                    onClick={() => {
                      setModValues((prevs) => ({
                        ...prevs,
                        isModOpen: true,
                        cardName: "edit",
                        rowData: row,
                        viewImage: row?.profile || BodyBuilder,
                      }));
                    }}
                  />
                </div>
                <div className="label-value-agent flexCol">
                  <span className="label">Gym Name</span>
                  <span className="value">{row?.gym_name || "NA"}</span>
                </div>

                <div className="label-value-agent flexCol">
                  <span className="label">Member Info</span>
                  <span className="value">
                    {row?.user_name || "NA"}
                    <br />
                    <small className="lowercase">
                      {row?.user_mobile || ""}
                      <br />
                      {row?.user_email || ""}
                    </small>
                  </span>
                </div>

                <div className="label-value-agent flexCol">
                  <span className="label">type</span>
                  <span className="value">{row?.type || "NA"}</span>
                </div>

                <div className="label-value-agent flexCol">
                  <span className="label">plan name</span>
                  <span className="value">{row?.plan_name || "NA"}</span>
                </div>

                <div className="label-value-agent flexCol">
                  <span className="label">price</span>
                  <span className="value">
                    ₹{convertThenFormat(row?.price || 0)}
                  </span>
                </div>

                <div className="label-value-agent flexCol">
                  <span className="label">start date</span>
                  <span className="value">
                    {row?.start_date ? formatDateTimezon(row.start_date) : "-"}
                  </span>
                </div>

                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-evenly",
                    alignItems: "center",
                    gap: "1rem",
                  }}
                >
                  <div className="actionButtonContainer" style={{ gap: "0" }}>
                    <b className="value">Invoice</b>
                    <button
                      type="button"
                      className="actionBtn icon download"
                      disabled={!row?.image}
                      style={{
                        cursor: !row?.image ? "not-allowed" : "pointer",
                      }}
                    >
                      <a href={row?.image}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-cloud-arrow-down"
                          viewBox="0 0 16 16"
                          style={{
                            color: !row?.image ? "gray" : "#CD0909",
                            minWidth: "35px",
                            minHeight: "35px",
                          }}
                        >
                          <path
                            fillRule="evenodd"
                            d="M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708z"
                          />
                          <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383m.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
                        </svg>
                      </a>
                    </button>
                  </div>

                  {isAdmin && (
                    <div className="actionButtonContainer" style={{ gap: "0" }}>
                      <b className="value">Edit</b>
                      <button
                        type="button"
                        className="actionBtn icon download"
                        disabled={!isEditable}
                        style={{
                          cursor: !isEditable ? "not-allowed" : "pointer",
                          opacity: !isEditable ? "0.5" : "1",
                        }}
                        onClick={() =>
                          isEditable &&
                          setModValues((prevs) => ({
                            ...prevs,
                            isModOpen: true,
                            cardName: "edit",
                            rowData: row,
                          }))
                        }
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-pencil-fill"
                          viewBox="0 0 16 16"
                          style={{
                            color: "#CD0909",
                          }}
                        >
                          <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
                        </svg>
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}

      <div className="lead-logs-card-pagination">
        <PaginationModified
          isPage={isPage}
          onChangePage={setIsPage}
          pagination={getPagination()}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
        />
      </div>
    </div>
  );
};

export default ImportMemberMobile;
